
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punelocalcabservice() {



    const cardData =
    {
        keyword: ' Pune Local Cab Service',
        heading: 'Mauli Cabs:  Pune Local Cab Service ',
        headingDescription: 'Mauli Cabs offers reliable and convenient Pune local cab services, perfect for daily commutes, shopping trips, and city tours. Whether you need a quick ride to your office, a day out exploring the city, or transportation for special events, we provide a variety of well-maintained vehicles including sedans, SUVs, and premium cabs to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a strong commitment to punctuality and customer satisfaction, Mauli Cabs ensures a smooth and enjoyable ride within Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Pune Local Cab Service",
      "description": "Book a local cab in Pune for city travel, meetings, shopping, or sightseeing. Choose from hatchbacks, sedans, and SUVs with hourly or full-day packages."
    },
    {
      "name": "Local Taxi Service in Pune",
      "description": "Reliable local taxi service in Pune for daily commute, errands, and visits. Well-maintained vehicles and professional drivers at your service 24/7."
    },
    {
      "name": "Local Cab in Pune",
      "description": "Hire a local cab in Pune for point-to-point or hourly travel. Affordable rates and quick response times ensure hassle-free city rides."
    },
    {
      "name": "Pune Local Cab Booking",
      "description": "Easily book a cab online for local use in Pune. Instant confirmation and live tracking available with a range of vehicle options."
    },
    {
      "name": "Local Taxi in Pune",
      "description": "Get a taxi for local travel in Pune. Ideal for office commutes, school runs, or quick shopping trips. Flexible hourly rentals available."
    },
    {
      "name": "Local Car Rental Pune",
      "description": "Rent a car in Pune for local travel. Choose from chauffeur-driven or self-drive options for daily or hourly rentals within the city."
    },
    {
      "name": "Taxi Services in Pune",
      "description": "Professional taxi services in Pune for local and outstation trips. On-time service, verified drivers, and clean vehicles are guaranteed."
    },
    {
      "name": "Cheapest Cab Service in Pune",
      "description": "Find the most affordable cab services in Pune for local travel. Transparent billing and no surge pricing even during peak hours."
    },
    {
      "name": "Best Cab Service in Pune",
      "description": "Experience top-rated cab services in Pune. Excellent customer support, professional drivers, and consistently high service quality."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Book taxis from Pune to outstation destinations like Mumbai, Shirdi, Mahabaleshwar and more. One-way and round-trip packages available."
    },
    {
      "name": "Cheapest Taxi Services in Pune",
      "description": "Explore Pune with the cheapest taxi options. Whether it's a short ride or a full-day hire, we offer competitive fares across all routes."
    },
    {
      "name": "Full Day Taxi in Pune",
      "description": "Hire a taxi in Pune for the whole day. Ideal for weddings, city tours, or business visits. Flexible 8/10/12-hour packages available."
    },
    {
      "name": "24 Hours Taxi Services in Pune",
      "description": "Round-the-clock taxi service in Pune for emergencies, airport drops, and night rides. Book any time, anywhere in the city."
    },
    {
      "name": "Pune Darshan Cab Service",
      "description": "Specialized cab service for Pune Darshan covering major attractions like Shaniwar Wada, Dagdusheth Ganpati, Saras Baug, and more."
    },
    {
      "name": "Pune Darshan Cab",
      "description": "Book a cab for Pune Darshan at affordable rates. Multiple tour packages available with guided options and experienced drivers."
    },
    {
      "name": "Pune to Mumbai Darshan Cab",
      "description": "Plan a day trip with our Pune to Mumbai Darshan cab service. Covers iconic spots like Gateway of India, Siddhivinayak Temple, and Marine Drive."
    },
    {
      "name": "Pune Darshan Cab Booking",
      "description": "Easily book Pune Darshan cabs online with choice of vehicle and duration. Tour covers both historical and spiritual locations."
    },
    {
      "name": "Pune Darshan Taxi",
      "description": "Taxi service for a full Pune Darshan tour with convenient pickup/drop from home or hotel. Ideal for families and tourists."
    },
    {
      "name": "Pune Darshan Taxi Service",
      "description": "Well-structured Pune Darshan packages with clean taxis, knowledgeable drivers, and flexible scheduling options."
    },
    {
      "name": "Pune to Ashtavinayak Cab",
      "description": "Hire a cab from Pune for Ashtavinayak Darshan covering all 8 temples. Comfortable vehicles and fixed package pricing available."
    },
    {
      "name": "Pune Local Innova Cab",
      "description": "Rent an Innova in Pune for local travel. Ideal for families or group tours with spacious interiors and air-conditioning."
    },
    {
      "name": "Pune to Lonavala Crysta Taxi",
      "description": "Book a Toyota Innova Crysta taxi from Pune to Lonavala for a premium travel experience. Perfect for weekend getaways and leisure travel."
    },
    {
      "name": "Pune Local Ertiga Cab Service",
      "description": "Hire a Maruti Ertiga cab in Pune for city use. A great option for 5–6 passengers with ample space and affordable rates."
    },
    {
      "name": "Pune Local Swift Dzire on Rent",
      "description": "Get a Swift Dzire on rent in Pune for local commutes, airport transfers, or hourly travel. Compact and budget-friendly."
    }
  ],
  "tableData": [
    ["Pune Local Cab Service", "Local Taxi Service in Pune"],
    ["Local Cab in Pune", "Pune Local Cab Booking"],
    ["Local Taxi in Pune", "Local Car Rental Pune"],
    ["Taxi Services in Pune", "Cheapest Cab Service in Pune"],
    ["Best Cab Service in Pune", "Outstation Taxi Service Pune"],
    ["Cheapest Taxi Services in Pune", "Full Day Taxi in Pune"],
    ["24 Hours Taxi Services in Pune", "Pune Darshan Cab Service"],
    ["Pune Darshan Cab", "Pune to Mumbai Darshan Cab"],
    ["Pune Darshan Cab Booking", "Pune Darshan Taxi"],
    ["Pune Darshan Taxi Service", "Pune to Ashtavinayak Cab"],
    ["Pune Local Innova Cab", "Pune to Lonavala Crysta Taxi"],
    ["Pune Local Ertiga Cab Service", "Pune Local Swift Dzire on Rent"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Convenient and Affordable Local Travel",
        "WhyChoosedescription": "Mauli Cabs offers reliable local cab services within Pune, ensuring a smooth and comfortable journey across the city. Whether it's for shopping, sightseeing, or business meetings, we provide an affordable and convenient travel solution."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "From hatchbacks to SUVs and sedans, we offer a variety of vehicles suited for solo travelers, families, or groups. Choose the vehicle that best meets your needs for a local trip in Pune."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, professional, and familiar with the local routes in Pune. They ensure timely, safe, and courteous service for a hassle-free local travel experience."
    },
    {
        "WhyChooseheading": "On-Demand and Flexible Booking",
        "WhyChoosedescription": "Whether you need a cab for a few hours or a full-day trip across Pune, Mauli Cabs offers flexible booking options. You can book your local ride on-demand via our website or app with ease."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy transparent pricing with no hidden charges. Our competitive rates for local Pune cabs ensure that you get the best service without overpaying."
    },
    {
        "WhyChooseheading": "Comfort and Convenience",
        "WhyChoosedescription": "All our cabs are air-conditioned and well-maintained for your comfort. Sit back and relax while we take care of the rest, whether you're traveling across Pune for business or leisure."
    },
    {
        "WhyChooseheading": "Quick and Easy Booking Process",
        "WhyChoosedescription": "Booking your Pune Local Cab is quick and simple. Use our website or app to book a ride in minutes. You’ll get instant confirmations and real-time tracking for your convenience."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs operates around the clock. Whether it’s a late-night trip or an early morning ride, our Pune local cab services are available 24/7 to accommodate your schedule."
    }
]






















    }


    const faqData = [
        {
            question: 'How do I book a local cab in Pune with Mauli Cabs?',
            answer: 'You can book a local cab in Pune through our website or mobile app by selecting the "Local" option and entering your pickup location, time, and duration of the ride. You can also call our customer support for bookings or special requirements.',
        },
        {
            question: 'What packages are available for Pune local travel?',
            answer: 'We offer multiple hourly packages such as 4 hours/40 km, 8 hours/80 km, and full-day options. These packages are ideal for business meetings, shopping, sightseeing, or daily errands within Pune city.',
        },
        {
            question: 'What types of cabs are available for local travel in Pune?',
            answer: 'Our Pune local cab fleet includes Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta. Choose your vehicle based on comfort, number of passengers, and luggage requirements.',
        },
        {
            question: 'Is the local cab fare fixed or based on kilometers?',
            answer: 'We offer both fixed-duration packages and kilometer-based pricing. Package rates are inclusive of fuel and driver charges. Any extra hours or kilometers are charged as per standard rates.',
        },
        {
            question: 'Are Mauli Cabs available for early morning and late-night local rides?',
            answer: 'Yes, Mauli Cabs operates 24/7 within Pune city. You can book a local ride at any hour for airport drops, railway station pickups, or urgent travel needs.',
        },
        {
            question: 'Can I modify or cancel my local cab booking?',
            answer: 'Yes, we offer flexible cancellation and modification options. You can make changes or cancel your ride through the app, website, or by contacting customer support.',
        },
        {
            question: 'Are Mauli Cabs drivers familiar with Pune city routes?',
            answer: 'Yes, our drivers are local experts who know Pune’s routes, landmarks, traffic shortcuts, and peak-hour patterns to ensure timely and smooth travel.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Pratik Deshmukh",
            position: "Marketing Executive",
            text: "I use Mauli Cabs frequently for meetings across Pune. Their drivers are punctual and the cars are always clean. It’s the most reliable local cab service I’ve used.",
            image: "/img/testimonial/testimonial-thumb-1-15.png",
        },
        {
            name: "Mrs. Shraddha Apte",
            position: "Homemaker",
            text: "Booked a cab for an 8-hour package to run errands around Pune. The experience was smooth, the driver was courteous, and the pricing was very fair. Highly recommended for city travel.",
            image: "/img/testimonial/testimonial-thumb-1-16.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune Local Cab Service by Mauli Cabs",
        "description": "Mauli Cabs provides the best local cab services in Pune including Pune Darshan, full-day bookings, and local rentals with vehicles like Innova Crysta, Ertiga, and Swift Dzire. Enjoy 24x7 availability and reliable local travel at affordable rates.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "6800"
        }
      };
      
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune Local Cab Service | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book reliable Pune local cab service with Mauli Cabs. Full-day, 24x7 local taxi services, Pune Darshan, and affordable cab options including Innova Crysta, Ertiga, and Swift Dzire. Best local taxi in Pune."
        />
        <meta
          name="keywords"
          content="pune local cab service, local taxi service in pune, local cab in pune, pune local cab booking, local taxi in pune, local car rental pune, Taxi Services in Pune, Cheapest cab service in Pune, Best cab service in Pune, Outstation taxi service Pune, Cheapest taxi services in pune, Full day taxi in Pune, 24 hours taxi services in pune, pune darshan cab service, pune darshan cab, pune to mumbai darshan cab, pune darshan cab booking, pune darshan taxi, pune darshan taxi service, pune to ashtavinayak cab, pune local innova cab, pune to lonavala crysta taxi, pune local ertiga cab service, Pune local Swift Dzire on Rent"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punelocalcabservice;